/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAdminsIdQueryResponse, GetApiAdminsIdPathParams, GetApiAdminsId400, GetApiAdminsId401, GetApiAdminsId403, GetApiAdminsId404, GetApiAdminsId500 } from "../../types/GetApiAdminsId.ts";
import { getApiAdminsIdQueryResponseSchema } from "../../zod/SuperAdminSchemas/getApiAdminsIdSchema.ts";

function getGetApiAdminsIdUrl({ id }: { id: GetApiAdminsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/admins/${id}` as const }  
  return res
}

/**
 * @summary Получение администратора по идентификатору (Доступно только для суперадмина)
 * {@link /api/admins/:Id}
 */
export async function getApiAdminsId({ id }: { id: GetApiAdminsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAdminsIdQueryResponse, ResponseErrorConfig<GetApiAdminsId400 | GetApiAdminsId401 | GetApiAdminsId403 | GetApiAdminsId404 | GetApiAdminsId500>, unknown>({ method : "GET", url : getGetApiAdminsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiAdminsIdQueryResponseSchema.parse(res.data)
}